import type { DrawButton, DrawFilters } from './types';

import type { Draw } from '@shared-types/draw.types';
import type { StateCreator } from '@shared-types/zustand.types';

type DrawSlice = {
  draw: Draw;
  setDraw: (payload: Draw) => void;
};

export const drawSlice: StateCreator<DrawSlice> = (set) => ({
  draw: null as Draw,
  setDraw: (payload: Draw) => set(() => ({ draw: payload }), false, 'setDraw'),
});

type DrawFiltersSlice = {
  filters: DrawFilters;
  setFilters: (payload: DrawFilters) => void;
};

export const filtersSlice: StateCreator<DrawFiltersSlice> = (set) => ({
  filters: {
    leagueId: null,
  },
  setFilters: (payload: DrawFilters) => set(() => ({ filters: payload }), false, 'setFilters'),
});

type DrawButtonSlice = {
  button: DrawButton;
  hideButton: () => void;
  showButton: (payload: Omit<DrawButton, 'isVisible'>) => void;
};

export const buttonSlice: StateCreator<DrawButtonSlice> = (set) => ({
  button: {
    isVisible: false,
  },
  hideButton: () => set((state) => ({ button: { ...state.button, isVisible: false } }), false, 'hideButton'),
  showButton: (payload: Omit<DrawButton, 'isVisible'>) =>
    set(
      () => ({
        button: {
          ...payload,
          isVisible: true,
        },
      }),
      false,
      'showButton',
    ),
});

export type DrawState = DrawSlice & DrawFiltersSlice & DrawButtonSlice;
